import React from 'react';

const QuestionItem = ({ idx, question, onChange, onRemove }) => {
  const { wording, choiceType, isRequired, options } = question;

  return (
    <div className="mt-3">
      <div>
        <strong>設問 {idx + 1}</strong>
        <button className="btn btn-info ml-3" onClick={onRemove}>
          削除
        </button>
      </div>
      <label htmlFor={`isRequired-${idx}`}>必須</label>
      <input
        type="checkbox"
        id={`isRequired-${idx}`}
        checked={!!isRequired}
        onChange={(e) => {
          onChange({ isRequired: e.target.checked });
        }}
        className="ml-2"
      />

      <div>
        <label>文言</label>
        <input
          type="text"
          className="form-control"
          value={wording}
          onChange={(e) => onChange({ wording: e.target.value })}
          placeholder="設問を入力"
        />
      </div>

      <div>
        <label>回答タイプ</label>
        <select
          className="form-control"
          value={choiceType}
          onChange={(e) => onChange({ choiceType: Number(e.target.value) })}
        >
          <option value={1}>一択</option>
          <option value={2}>複数選択可</option>
          <option value={3}>フリーテキスト</option>
        </select>
      </div>

      {/* フリーテキストの場合は、選択肢は必要ないので、表示しない */}
      {choiceType !== 3 && (
        <div className="mt-3">
          <label>選択肢</label>
          {options.map((opt, j) => (
            <div key={j}>
              <input
                type="text"
                className="form-control mt-2"
                value={opt}
                onChange={(e) => {
                  const newOptions = [...options];
                  newOptions[j] = e.target.value;
                  onChange({ options: newOptions });
                }}
                placeholder="選択肢を入力"
              />
              <div>
                <button
                  className="btn btn-info my-2"
                  onClick={() => {
                    const newOptions = options.filter((_, k) => k !== j);
                    onChange({ options: newOptions });
                  }}
                >
                  -
                </button>
              </div>
            </div>
          ))}
          <button
            className="d-block btn btn-info mt-2"
            onClick={() => {
              onChange({ options: options.concat('') });
            }}
          >
            + 選択肢を追加
          </button>
        </div>
      )}
    </div>
  );
};

export default QuestionItem;
